import { styled } from "goober";

export const StackTrace = styled("pre")`
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  margin: var(--sp-8) !important;
  text-align: left;
  max-height: 15rem;
  overflow: auto;
  padding: var(--sp-2) var(--sp-4);
  background: var(--shade7);
  border-radius: var(--br-lg);
  resize: none;

  a {
    text-decoration: underline;
  }
`;
